import {Component} from "react";
import moment from "moment-timezone";

class DateText extends Component {
    render() {
        if (this.props.date === undefined || this.props.date === "") {
            return "-";
        }
        if (this.props.relativeTime !== undefined && this.props.relativeTime) {
            return this.relativeTime(this.props.date);
        }
        return moment(new Date(this.props.date.toString())).format("MM/DD/YYYY h:mmA");
    }

    relativeTime = date => {
        if (date === "N/A" || date === undefined) {
            return "-";
        }
        if (Math.abs(moment(date).diff()) < 25000) {
            // 25 seconds before or after now
            return "just now";
        }
        return moment(date).fromNow();
    };
}

export default DateText;


// WEBPACK FOOTER //
// ./src/common/DateText/DateText.js